export default {
  currencyCode: null,
  tenant: [],
}
